import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export const getListTestimoni = async (search?: any, page?: any) => {
    let url = `${API_URLS}/testimonis?populate=*&`
    if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
    if (search) url += `_q=${search}&`
    try {
      const response = await axios.get(url)
      return Promise.resolve(response.data)
    } catch (error) {
      return Promise.reject(error)
    }
}

export const getDetailTesti = async (id: any) => {
  let url = `${API_URLS}/testimonis/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}